import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import './index.css';

const CourseCard = ({ course, index = 0, onClick }) => {
  const Icon = course.icon;
  const sections = course.curriculumData?.curriculum ?? [];
  const topicCount = sections.reduce((sum, s) => sum + s.topics.length, 0);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <article
      className={`course-tile ${course.featured ? 'featured' : ''}`}
      style={{
        '--accent-1': course.accent[0],
        '--accent-2': course.accent[1],
        animationDelay: `${index * 80}ms`
      }}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`View ${course.title} curriculum`}
    >
      <div className="course-tile-glow" aria-hidden="true" />

      <div className="course-tile-body">
        <div className="course-tile-top">
          <div className="course-tile-icon">
            <Icon sx={{ fontSize: course.featured ? 34 : 28 }} />
          </div>
          <div className="course-tile-badges">
            {course.featured && <span className="badge badge-accent">Flagship</span>}
            {course.isNew && <span className="badge badge-accent">New</span>}
            <span className="badge">{course.level}</span>
          </div>
        </div>

        {course.tagline && <span className="course-tile-tagline">{course.tagline}</span>}
        <h3 className="course-tile-title">{course.title}</h3>
        <p className="course-tile-desc">{course.description}</p>

        {course.stack && (
          <ul className="course-tile-stack">
            {course.stack.map((tech) => (
              <li key={tech.name} title={tech.name}>
                <img src={tech.logo} alt="" loading="lazy" />
                <span>{tech.name}</span>
              </li>
            ))}
          </ul>
        )}

        {course.tags && (
          <ul className="course-tile-tags">
            {course.tags.map((tag) => <li key={tag}>{tag}</li>)}
          </ul>
        )}
      </div>

      <div className="course-tile-footer">
        <div className="course-tile-meta">
          <span><ScheduleIcon sx={{ fontSize: 16 }} /> {course.duration}</span>
          <span><MenuBookIcon sx={{ fontSize: 16 }} /> {sections.length} modules · {topicCount} topics</span>
        </div>
        <span className="course-tile-cta">
          View curriculum <ArrowForwardIcon sx={{ fontSize: 18 }} />
        </span>
      </div>
    </article>
  );
};

export default CourseCard;
